export default "__VITE_ASSET__NEHgC5AD__"